import AppError from './AppError';

export default class SubclassResponsabilityError extends AppError {
	constructor() {
		super( { name: 'SubclassResponsabilityError' } );
	}
}
